import { render } from "./logotype_footer.vue?vue&type=template&id=c1fe1b82&scoped=true"
import script from "./logotype_footer.vue?vue&type=script&lang=js"
export * from "./logotype_footer.vue?vue&type=script&lang=js"

import "./logotype_footer.vue?vue&type=style&index=0&id=c1fe1b82&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1fe1b82"]])

export default __exports__